<app-spinner></app-spinner>
<router-outlet></router-outlet>
<p-toast position="top-center"></p-toast>